import { GetProp, TableProps } from "antd";
import { utilityService } from "shared/services";
import { IProjectDetails } from "projects/models";
import { Link } from "react-router-dom";
import { IOrganization } from "organizations/models";
import { buildOrganizationSectionPath } from "shared/utils/paths";

type ColumnsType<T extends object> = GetProp<TableProps<T>, "columns">;

export const getProjectsDetailsColumns = (organization: IOrganization | undefined): ColumnsType<IProjectDetails> => [
  {
    title: "",
    dataIndex: "id",
    render: (value, record, index) => index + 1,
  },
  {
    title: "Project",
    dataIndex: "projectName",
    render: (value, record, index) => (
      <Link to={buildOrganizationSectionPath(organization, `projects/${record.id}`)}>
        {utilityService.truncateField(value)}
      </Link>
    ),
  },
  {
    title: "Project Value",
    dataIndex: "projectValue",
    render: (value, record, index) =>
      `$${utilityService.statisticsFormatter(value)}`,
  },
];
